import React, { FunctionComponent, ReactNode } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

/**
 * To make rows of alternating background color for easier tracking; use like <TableRow sx={zebraStripingSx}>
 */
export const zebraStripingSx = {
  '&:nth-of-type(odd)': {
    backgroundColor: '#606060',
  },
};

interface Props {
  readonly title?: string;
  readonly columns: string[];
  readonly children: ReactNode;
  readonly paperElevation?: number;
}

export const PropertyTable: FunctionComponent<Props> = (props) => (
  <Paper sx={{ p: 1, mb: 2 }} elevation={props.paperElevation}>
    {props.title && <Typography variant="subtitle1">{props.title}</Typography>}
    <Table>
      <TableHead>
        <TableRow>
          {props.columns.map((column) => (
            <TableCell key={column}>{column}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{props.children}</TableBody>
    </Table>
  </Paper>
);
